import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=56d12082&scoped=true"
import script from "./Completion.vue?vue&type=script&lang=js"
export * from "./Completion.vue?vue&type=script&lang=js"
import style0 from "./Completion.vue?vue&type=style&index=0&id=56d12082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d12082",
  null
  
)

export default component.exports